import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["propsToDisplay"];
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { getSingleEntitySchema, buildPropsQuery } from '@blaze-cms/react-page-builder';
import { MainContext } from '@blaze-cms/nextjs-components';
import GTMEventRender from './GTMEventRender';
import { getRenderProps, getIdsToUse, buildPropsToDisplayArray } from '../helpers';
import { GTM_EVENT_FACTORY } from '../constants';
const GTMEventFactory = ({
  parent,
  gtmEvents,
  parentData,
  clickId,
  parentComponent
}) => {
  const {
    isPreview
  } = useContext(MainContext);
  const [{
    itemEntity = parent.itemEntity
  } = {}] = parentData || [];
  const {
    data,
    error,
    loading
  } = useQuery(getSingleEntitySchema, {
    variables: {
      id: itemEntity
    }
  });
  if (loading || error || !data) return null;
  return gtmEvents.map((_ref, i) => {
    let {
        propsToDisplay
      } = _ref,
      eventProps = _objectWithoutProperties(_ref, _excluded);
    const hasNoPropsToDisplay = !propsToDisplay || !propsToDisplay.length;
    const propsToDisplayArr = buildPropsToDisplayArray(propsToDisplay);
    const extraProps = hasNoPropsToDisplay ? '' : buildPropsQuery(data, propsToDisplayArr);
    const shouldUseParentData = !clickId && parentData && parentData.length;
    const itemIdToUse = clickId || parent.itemId;
    const itemId = shouldUseParentData ? getIdsToUse(parentData) : itemIdToUse;
    const shouldUseMultiQuery = Array.isArray(itemId);
    const {
      action,
      actionKey
    } = getRenderProps(extraProps, isPreview, data, shouldUseMultiQuery);
    const dynamicKey = `${GTM_EVENT_FACTORY}${i}`;
    const queryVariables = shouldUseMultiQuery ? {
      variables: {
        where: {
          id: {
            _in: itemId
          }
        }
      },
      skip: hasNoPropsToDisplay
    } : {
      variables: {
        id: itemId
      },
      skip: hasNoPropsToDisplay
    };
    return /*#__PURE__*/React.createElement(GTMEventRender, _extends({
      key: dynamicKey,
      action: action,
      actionKey: actionKey,
      propsToDisplay: propsToDisplay,
      id: itemId,
      queryVariables: queryVariables,
      parentComponent: parentComponent
    }, eventProps));
  });
};
GTMEventFactory.propTypes = {
  parent: PropTypes.object.isRequired,
  clickId: PropTypes.string,
  gtmEvents: PropTypes.array,
  parentData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  parentComponent: PropTypes.object
};
GTMEventFactory.defaultProps = {
  clickId: null,
  gtmEvents: [],
  parentData: null,
  parentComponent: {}
};
export default GTMEventFactory;
//# sourceMappingURL=GTMEventFactory.js.map